import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import calendarActionStyles from './calendarActionBar.scss';
import PageActionButton from 'components/PageActionButton';
import cx from 'classnames';
import getMobileOperatingSystem from '../../../utils/mobileUtils';

class CalendarActionBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: '',
      currentTab: '',
      isMobile: '',
    };
  }
  componentDidMount() {
    this.setPath();
  }

  setPath() {
    this.setState({
      currentPage: document.URL.split('/')[3],
      currentTab: document.URL.split('/')[5],
      isMobile: getMobileOperatingSystem() !== 'unknown',
    });
  }

  renderFilterBtn() {
    const { showFiltersBtn, toggleFilters, userRestrictedFilters, role } = this.props;

    return (!['installer', 'estimator'].includes(role) && showFiltersBtn && !userRestrictedFilters ? (
      <PageActionButton
        actionText="Filter"
        actionIcon="filter_list"
        action={toggleFilters}
        actionColor="orange"
      />
    ) : null);
  }

  render() {
    const {
      title,
      banner,
      subTitle,
      children,
      currentPage,
      currentTab,
    } = this.props;
    return (
      <div
        className={cx(calendarActionStyles.calendarActionBarContainer, {
          [calendarActionStyles.mobile]: this.state.isMobile &&
            currentTab === 'appointments',
          [calendarActionStyles.inAppointments]: currentTab === 'appointments',
          [calendarActionStyles.inSchedule]: currentPage === 'schedule',
        })}
      >
        <Helmet title={title} />
        {this.renderFilterBtn()}
        <div className={calendarActionStyles.title}>
          <div>
            {title}
            <span className={calendarActionStyles.banner}>
              {banner}
            </span>
            <div className={calendarActionStyles.subTitle}>{subTitle}</div>
          </div>
        </div>
        {children || <div className={calendarActionStyles.middle} />}
      </div>
    );
  }
}

CalendarActionBar.propTypes = {
  showFiltersBtn: PropTypes.bool,
  userRestrictedFilters: PropTypes.bool,
  toggleFilters: PropTypes.func,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  banner: PropTypes.string,
  children: PropTypes.node,
  currentTab: PropTypes.string,
  currentPage: PropTypes.string,
  role: PropTypes.string,
};

CalendarActionBar.defaultProps = {
  showFiltersBtn: true,
  userRestrictedFilters: false,
};

export default CalendarActionBar;



// WEBPACK FOOTER //
// ./client/app/shared/components/CalendarActionBar/index.jsx